export const getEventData = key => {
  const value = localStorage.getItem(key);

  if (value === 'undefined') {
    return '';
  }

  return JSON.parse(value) || '';
};

export const setEventData = eventData => {
  Object.keys(eventData).forEach(key => {
    const value = eventData[key];

    // Undefined value will be set as string undefined in localStorage

    localStorage.setItem(key, JSON.stringify(value));
  });
};

export const invalidateAlertData = ({ defaultTime, studentClassroomId }) => {
  setEventData({
    incorrectCount: 0,
    incorrectAlert: false,
    inactiveAlert: false,
    doubtsAlert: false,
    lastAttemptTime: defaultTime,
    lastActivityTime: defaultTime,
    studentClassroomId,
  });
};
